import { ActionTree, Commit } from 'vuex';
import { IState } from './state';
import config from '@/params/config';
import * as TYPES from './types';
import { apiFetchAction } from '../apiUtil';

// const apiRoot: string = `${config.neo}/${config.apiVersion}`;
const apiRoot: string = config.neo;

interface IActionContent {
    state: IState;
    commit: Commit;
}

// 获取公告分页数据信息
const getSystemConfig = async (content: IActionContent, payload: object) => {    
    await apiFetchAction(
        content.commit,
        'Config/GetListProductExpCenterDTO',
        'GET',
        (payload as any).code === '产品体验中心' ? TYPES.GET_SYSTEMCONFIG_NAME : TYPES.GET_LEFT_SYSTEMCONFIG_NAME,
        payload, false, apiRoot);
};

// 获取产品文档列表 ---类型
const getFolderFiles = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'FileCloud/GetFolderFiles',
        'POST',
        TYPES.GET_FOLDER_FILES_NAME,
        payload, false, apiRoot);
};

export const actions = {
    getSystemConfig,
    getFolderFiles
};
